import React from 'react';

const DeleteConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  department, 
  deleting = false 
}) => {
  if (!isOpen || !department) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4 bg-gray-900/60 backdrop-blur-xs transition-all animate-fade-in">
      {/* Backdrop listener */}
      <div className="fixed inset-0" onClick={!deleting ? onClose : undefined} aria-hidden="true" />

      {/* Modal Card Layout */}
      <div className="relative w-full sm:max-w-md bg-white rounded-t-2xl sm:rounded-xl shadow-2xl overflow-hidden border-none sm:border border-gray-100 max-h-[90dvh] flex flex-col">
        
        {/* Header Section */}
        <div className="px-4 py-5 sm:px-6 border-b border-gray-100 flex-shrink-0">
          <div className="flex items-start space-x-3.5">
            <div className="flex-shrink-0">
              <div className="w-10 h-10 bg-red-50 rounded-lg border border-red-100 flex items-center justify-center">
                <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
              </div>
            </div>
            <div className="min-w-0 flex-1">
              <h2 className="text-base sm:text-lg font-bold text-gray-900 truncate">Delete Department</h2>
              <p className="text-red-600 font-semibold mt-0.5 text-xs">
                This process cannot be reversed.
              </p>
            </div>
          </div>
        </div>

        {/* Content Body Section */}
        <div className="px-4 py-5 sm:px-6 overflow-y-auto text-sm text-gray-600 min-h-0 flex-1 leading-relaxed">
          <p>
            Are you sure you want to delete <span className="font-bold text-gray-900">"{department.name}"</span>? 
            This operation will permanently remove the department and all associated institutional data.
          </p>
        </div>

        {/* Footer Actions Section */}
        <div className="px-4 py-4 sm:px-6 bg-gray-50 border-t border-gray-100 flex-shrink-0 pb-safe">
          <div className="flex flex-col-reverse sm:flex-row gap-2 sm:space-x-3 sm:justify-end">
            <button
              type="button"
              onClick={onClose}
              disabled={deleting}
              className="w-full sm:w-auto px-5 py-3 sm:py-2 border border-gray-300 bg-white text-gray-700 rounded-lg hover:bg-gray-50 disabled:opacity-50 transition font-semibold text-sm shadow-xs"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={deleting}
              className="w-full sm:w-auto px-5 py-3 sm:py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition font-semibold text-sm flex items-center justify-center space-x-2 shadow-xs"
            >
              {deleting ? (
                <>
                  <svg className="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"/>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                  </svg>
                  <span>Deleting...</span>
                </>
              ) : (
                <span>Delete Department</span>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;